<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div>
		<div class="flex justify-end pr-2">
			<vs-dropdown vs-trigger-click class="cursor-pointer mb-2" vs-custom-content>
				<feather-icon icon="GridIcon" svgClasses="h-6 w-6 hover:text-warning" @click.prevent></feather-icon>
				<vs-dropdown-menu style="width: 300px; z-index: 200001">
					<div class="vx-row p-4">
						<div class="vx-col w-full mb-2">
							<vs-checkbox v-model="isCardVisible.card1">
								{{ $t("Optimization.OptimizationsCompletedByRouter") }}
							</vs-checkbox>
						</div>
						<div class="vx-col w-full mb-2">
							<vs-checkbox v-model="isCardVisible.card2">
								{{ $t("Group.OptimizationsByGroup") }}
							</vs-checkbox>
						</div>
						<div class="vx-col w-full mb-2">
							<vs-checkbox v-model="isCardVisible.card3">
								{{ $t("LimitvsServiceConsumption") }}
							</vs-checkbox>
						</div>
						<div class="vx-col w-full">
							<vs-checkbox v-model="isCardVisible.card4">
								{{ $t("ConsumptionPerService") }}
							</vs-checkbox>
						</div>
					</div>
				</vs-dropdown-menu>
			</vs-dropdown>
		</div>
		<div class="vx-row mb-4">
			<div
				class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 cursor-pointer"
				@click.prevent="showOptimizationList('All', totalOptimization)"
			>
				<statistics-card-line
					icon="TrendingUpIcon"
					type="area"
					:statistic="totalOptimization"
					:statisticTitle="$t('Optimization.Optimizations')"
					:chartData="optimizationTotal"
				/>
			</div>
			<div
				class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 cursor-pointer"
				@click.prevent="showOptimizationList('FINALIZED', totalFinalized)"
			>
				<statistics-card-line
					icon="CheckCircleIcon"
					type="area"
					color="success"
					:statistic="totalFinalized"
					:statisticTitle="$t('Optimization.OptimizationsCompleted')"
					:chartData="optimizationFinalized"
				/>
			</div>
			<div
				class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 cursor-pointer"
				@click.prevent="showOptimizationList('PROCESSING', totalProcessing)"
			>
				<statistics-card-line
					icon="RefreshCwIcon"
					color="warning"
					type="area"
					:statistic="totalProcessing"
					:statisticTitle="$t('Optimization.OptimizationsInProgress')"
					:chartData="optimizationProcessing"
				/>
			</div>
			<div
				class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 cursor-pointer"
				@click.prevent="showOptimizationList('ERROR', totalError)"
			>
				<statistics-card-line
					icon="AlertCircleIcon"
					color="danger"
					type="area"
					:statistic="totalError"
					:statisticTitle="$t('Optimization.OptimizationsWithErrors')"
					:chartData="optimizationError"
				/>
			</div>
		</div>
		<div class="vx-row mb-3">
			<div
				v-if="isCardVisible.card1"
				class="vx-col w-full"
				:class="{'md:w-1/3': isCardVisible.card1 && isCardVisible.card2}"
			>
				<vx-card :title="$t('Optimization.OptimizationsCompletedByRouter')">
					<div slot="no-body">
						<vue-apex-charts
							type="pie"
							height="345"
							class="mt-10 mb-10"
							:options="analyticsData.customersRouter.chartOptions"
							:series="[totalOpenroute, totalGmpro, totalTourPlaning]"
						/>
						<ul class="mb-1">
							<li
								v-for="item in analyticsDataRouter"
								:key="item.router"
								class="flex justify-between py-3 px-6 border d-theme-border-grey-light border-solid border-r-0 border-l-0 border-b-0"
							>
								<span class="flex items-center">
									<span
										class="inline-block h-3 w-3 rounded-full mr-2"
										:style="{backgroundColor: item.color}"
									></span>
									<span class="font-semibold">{{ item.router }}</span>
								</span>
								<span>{{ item.count }}</span>
							</li>
						</ul>
					</div>
				</vx-card>
			</div>
			<div
				v-if="isCardVisible.card2"
				class="vx-col w-full"
				:class="{'md:w-2/3': isCardVisible.card1 && isCardVisible.card2}"
			>
				<vx-card class="pb-1" :title="$t('Group.OptimizationsByGroup')">
					<group-optimization-history />
				</vx-card>
			</div>
		</div>
		<div class="vx-row">
			<div
				v-if="isCardVisible.card3"
				id="limit-period-div"
				class="vx-col w-full mb-4"
				:class="{'md:w-1/3 lg:w-1/3 xl:w-1/3': isCardVisible.card3 && isCardVisible.card4}"
			>
				<vx-card
					id="limit-period-content-loading"
					class="vs-con-loading__container"
					:title="$t('LimitvsServiceConsumption')"
				>
					<template slot="actions">
						<vs-dropdown vs-trigger-click class="cursor-pointer">
							<small class="flex cursor-pointer">
								<span>{{ selectedPeriod.label }}</span>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
							</small>
							<vs-dropdown-menu class="w-42">
								<vs-dropdown-item @click="filterByPeriod('total')">{{
									$t("Totalconsumption")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByPeriod('total_last_1_day')">{{
									$t("Last1Day")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByPeriod('total_last_7_days')">{{
									$t("Last7Days")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByPeriod('total_last_month')">{{
									$t("LastMonth")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByPeriod('total_current_subscription')">{{
									$t("TotalSubscriptionMonthly")
								}}</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</template>
					<div
						class="flex items-center justify-between mb-4 p-2 border d-theme-dark-bg d-theme-border-grey-light border-solid"
					>
						<span>{{ visibleCards[0] }}</span>
						<div>
							<feather-icon
								icon="ArrowLeftIcon"
								class="cursor-pointer"
								svgClasses="['stroke-current h-4 w-4 mb-1 mr-1']"
								:class="currentIndex === 0 ? 'text-grey font-light' : 'text-black'"
								:disabled="currentIndex === 0"
								@click="previousCard()"
							></feather-icon>
							<feather-icon
								icon="ArrowRightIcon"
								class="cursor-pointer"
								svgClasses="['stroke-current h-4 w-4 mb-1 mr-1']"
								:class="
									currentIndex === cards.length - cardsPerPage ? 'text-grey font-light' : 'text-black'
								"
								:disabled="currentIndex === cards.length - cardsPerPage"
								@click="nextCard()"
							></feather-icon>
						</div>
					</div>
					<div v-for="(item, index) in limitedVsUsedServices" :key="item.service" :class="{'mt-6': index}">
						<div class="flex justify-between">
							<div class="flex flex-col">
								<span class="mb-1">{{ textService(item.service) }}</span>
								<h4>{{ !isNaN(limitPercent(item)) ? limitPercent(item) : 0 }}%</h4>
							</div>
							<div class="flex flex-col text-right">
								<span class="flex -mr-1">
									<span class="mr-1">{{ limitPoint(item) }}</span>
									<feather-icon
										icon="ArrowUpIcon"
										class="text-success"
										svgClasses="['stroke-current h-4 w-4 mb-1 mr-1']"
									></feather-icon>
								</span>
								<span class="text-grey">{{ $t("Points") }}</span>
							</div>
						</div>
						<vs-progress :percent="!isNaN(limitPercent(item)) ? limitPercent(item) : 0"></vs-progress>
					</div>
				</vx-card>
			</div>
			<div
				v-if="isCardVisible.card4"
				class="vx-col w-full"
				:class="{'md:w-2/3': isCardVisible.card3 && isCardVisible.card4}"
			>
				<vx-card
					id="used-content-loading"
					class="vs-con-loading__container"
					:title="$t('ConsumptionPerService')"
				>
					<template slot="actions">
						<vs-dropdown vs-trigger-click class="cursor-pointer">
							<small class="flex cursor-pointer">
								<span>{{ selectedUsedService.label }}</span>
								<feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
							</small>
							<vs-dropdown-menu style="width: 141px">
								<vs-dropdown-item @click="filterByUsedService('all')">{{
									$t("Totalconsumption")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByUsedService('total_last_1_day')">{{
									$t("Last1Day")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByUsedService('total_last_7_days')">{{
									$t("Last7Days")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByUsedService('total_last_month')">{{
									$t("LastMonth")
								}}</vs-dropdown-item>
								<vs-dropdown-item @click="filterByUsedService('total_current_subscription')">{{
									$t("TotalSubscriptionMonthly")
								}}</vs-dropdown-item>
							</vs-dropdown-menu>
						</vs-dropdown>
					</template>
					<vue-apex-charts
						type="bar"
						height="440"
						:options="customerServicePeriod.chartOptions"
						:series="customerServicePeriod.series"
					/>
				</vx-card>
			</div>
		</div>
		<vs-popup
			class="vs-popup--content-custom"
			:fullscreen="true"
			:title="$t('Optimization.ListOfOptimizations')"
			:active.sync="optimizationListMounted"
		>
			<optimization-list
				v-if="optimizationListMounted"
				:statusOptimization="statusOptimization"
				:showInPopup="true"
			/>
		</vs-popup>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./ui-elements/card/analyticsData.js";
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import GroupOptimizationHistory from "@/components/optimization-group/GroupOptimizationHistory.vue";
import OptimizationList from "@/components/optimization/OptimizationList.vue";

export default {
	components: {
		VueApexCharts,
		StatisticsCardLine,
		VuePerfectScrollbar,
		GroupOptimizationHistory,
		OptimizationList,
	},
	data() {
		return {
			analyticsData,
			totalError: 0,
			totalFinalized: 0,
			totalProcessing: 0,
			totalOptimization: 0,
			totalOpenroute: 0,
			totalGmpro: 0,
			totalTourPlaning: 0,
			totalOptimizationServiceOpenroute: 0,
			totalRoutingServiceOpenroute: 0,
			totalMatrixServiceOpenroute: 0,
			totalMapMatchingServiceOpenroute: 0,
			totalIsochronesServiceOpenroute: 0,
			totalOptimizationServiceGmpro: 0,
			totalRoutingServiceGmpro: 0,
			totalMatrixServiceGmpro: 0,
			totalMapMatchingServiceGmpro: 0,
			totalIsochronesServiceGmpro: 0,
			totalOptimizationServiceTourPlanning: 0,
			totalRoutingServiceTourPlanning: 0,
			totalMatrixServiceTourPlanning: 0,
			totalMapMatchingServiceTourPlanning: 0,
			totalIsochronesServiceTourPlanning: 0,
			optimizationTotal: [],
			optimizationError: [],
			optimizationFinalized: [],
			optimizationProcessing: [],
			analyticsDataRouter: [],
			usedPeriodStatistics: [],
			limitedVsUsedServices: [],
			optimizationListMounted: false,
			statusOptimization: "",
			selectedPeriod: {label: this.$t("Totalconsumption"), value: "total"},
			selectedUsedService: {label: this.$t("Totalconsumption"), value: "all"},
			cards: ["OPENROUTE", "GMPRO", "TOUR_PLANNING"],
			currentIndex: 0,
			cardsPerPage: 1,
			isCardVisible: {
				card1: true,
				card2: true,
				card3: true,
				card4: true,
			},
		};
	},
	computed: {
		visibleCards() {
			return this.cards.slice(this.currentIndex, this.currentIndex + this.cardsPerPage);
		},
		scrollbarTag() {
			return this.$store.getters.scrollbarTag;
		},
		limitPercent() {
			return (item) => {
				const periodMapping = {
					total: {totalKey: "total", pointsKey: "points_total"},
					total_last_1_day: {totalKey: "total_last_1_day", pointsKey: "points_per_day"},
					total_last_7_days: {totalKey: "total_last_7_days", pointsKey: "points_per_week"},
					total_last_month: {totalKey: "total_last_month", pointsKey: "points_per_month"},
					total_current_subscription: {
						totalKey: "total_current_subscription",
						pointsKey: "points_subscription_monthly",
					},
				};
				const period = this.selectedPeriod.value;
				if (!periodMapping[period]) return 0; // Si no existe el período, retorna 0.
				const {totalKey, pointsKey} = periodMapping[period];
				const total = item[totalKey];
				const points = item[pointsKey];
				if (points != null && total > points) return 100;
				const pointsTotal = points === null ? total * 2 : points;
				return Math.round((total / pointsTotal) * 100);
			};
		},
		limitPoint() {
			return (item) => {
				const period = this.selectedPeriod.value;
				const pointsKey = {
					total: "points_total",
					total_last_1_day: "points_per_day",
					total_last_7_days: "points_per_week",
					total_last_month: "points_per_month",
					total_current_subscription: "points_subscription_monthly",
				}[period];
				const points = item[pointsKey];
				return points === null ? this.$t("Unlimited") : points;
			};
		},
		textService() {
			return (value) => {
				if (value === "optimization") return this.$t("Optimization.Optimization");
				else if (value === "routing") return this.$t("RoutingService");
				else if (value === "matrix") return this.$t("Matrix");
				else if (value === "mapmatching") return this.$t("MapMatching");
				else if (value === "isochrones") return this.$t("Isochrones");
			};
		},
		customerServicePeriod() {
			return {
				chartOptions: {
					grid: {
						borderColor: "#ebebeb",
						padding: {
							left: 0,
							right: 0,
						},
					},
					legend: {
						show: true,
						position: "top",
					},
					dataLabels: {
						enabled: false,
					},
					stroke: {
						show: true,
						width: 2,
						colors: ["transparent"],
					},
					chart: {
						type: "bar",
						toolbar: {show: false},
					},
					colors: ["#b5152b", "#3D79B8", "#30b59a"],
					plotOptions: {
						bar: {
							horizontal: false,
							columnWidth: "55%",
							borderRadius: 5,
							borderRadiusApplication: "end",
						},
					},
					xaxis: {
						title: {
							text: this.$t("TypeOfService"),
						},
						labels: {
							style: {
								cssClass: "text-secondary fill-current",
							},
						},
						axisTicks: {
							show: false,
						},
						categories: [
							this.$t("Optimization.Optimization"),
							this.$t("RoutingService"),
							this.$t("Matrix"),
							this.$t("MapMatching"),
							this.$t("Isochrones"),
						],
						axisBorder: {
							show: true,
						},
					},
					yaxis: {
						title: {
							text: this.$t("Routing.Title.VisitPoints"),
						},
						tickAmount: 5,
						labels: {
							style: {
								cssClass: "text-secondary fill-current",
							},
						},
					},
					tooltip: {
						x: {show: true},
					},
				},
				series: [
					{
						name: "OPENROUTE",
						data: [
							this.totalOptimizationServiceOpenroute,
							this.totalRoutingServiceOpenroute,
							this.totalMatrixServiceOpenroute,
							this.totalMapMatchingServiceOpenroute,
							this.totalIsochronesServiceOpenroute,
						],
					},
					{
						name: "GMPRO",
						data: [
							this.totalOptimizationServiceGmpro,
							this.totalRoutingServiceGmpro,
							this.totalMatrixServiceGmpro,
							this.totalMapMatchingServiceGmpro,
							this.totalIsochronesServiceGmpro,
						],
					},
					{
						name: "TOUR PLANING",
						data: [
							this.totalOptimizationServiceTourPlanning,
							this.totalRoutingServiceTourPlanning,
							this.totalMatrixServiceTourPlanning,
							this.totalMapMatchingServiceTourPlanning,
							this.totalIsochronesServiceTourPlanning,
						],
					},
				],
			};
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
		this.optimizationGroupFilter();
		this.optimizationFilter();
	},
	mounted() {
		this.getManagerOptimizer("all");
		this.getManagerOptimizerByRouter(this.cards[this.currentIndex], this.selectedPeriod.value);
	},
	methods: {
		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		showOptimizationList(status, valueTotal) {
			if (valueTotal != 0) {
				this.statusOptimization = status;
				this.optimizationListMounted = true;
			}
		},
		optimizationGroupFilter() {
			this.$store
				.dispatch("moduleOptimizationGroup/optimizationGroupFilter", {})
				.then((res) => {
					for (let item of res.records) {
						this.totalFinalized += item.total_finalized;
						this.totalProcessing += item.total_processing;
						this.totalError += item.total_error + item.total_created;
					}
					this.totalOptimization = this.totalFinalized + this.totalProcessing + this.totalError;
				})
				.catch((err) => {
					console.error(err);
				});
		},
		optimizationFilter() {
			const payload = {
				status: ["CREATED", "PROCESSING", "FINALIZED", "ERROR"],
			};
			this.$store
				.dispatch("moduleOptimization/optimizationFilter", payload)
				.then((res) => {
					if (res.records.length > 0) {
						this.totalOpenroute = res.records.filter(
							(data) => data.routing_api === "OPENROUTE" && data.status === "FINALIZED"
						).length;
						this.totalGmpro = res.records.filter(
							(data) =>
								(data.routing_api === "GMPRO" || data.routing_api === "FLEET_ROUTING") &&
								data.status === "FINALIZED"
						).length;
						this.totalTourPlaning = res.records.filter(
							(data) => data.routing_api === "TOUR_PLANNING" && data.status === "FINALIZED"
						).length;
						this.analyticsDataRouter.push(
							{router: "OPENROUTE", count: this.totalOpenroute, color: "#b5152b"},
							{router: "GMPRO", count: this.totalGmpro, color: "#3D79B8"},
							{router: "TOUR_PLANNING", count: this.totalTourPlaning, color: "#30b59a"}
						);
						const groupedOptimizations = {
							CREATED: [],
							FINALIZED: [],
							PROCESSING: [],
							ERROR: [],
						};
						res.records.forEach(({status, id}) => {
							if (groupedOptimizations[status]) {
								groupedOptimizations[status].push(id);
							}
						});
						this.optimizationFinalized.push({
							name: this.$t("Optimization.Optimization"),
							data: groupedOptimizations["FINALIZED"],
						});
						this.optimizationProcessing.push({
							name: this.$t("Optimization.Optimization"),
							data: groupedOptimizations["PROCESSING"],
						});
						this.optimizationError.push({
							name: this.$t("Optimization.Optimization"),
							data: [...groupedOptimizations["ERROR"], ...groupedOptimizations["CREATED"]],
						});
						this.optimizationTotal.push({
							name: this.$t("Optimization.Optimization"),
							data: [
								...groupedOptimizations["FINALIZED"],
								...groupedOptimizations["PROCESSING"],
								...groupedOptimizations["CREATED"],
								...groupedOptimizations["ERROR"],
							],
						});
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},
		getManagerOptimizer(period) {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			const payload = {
				company_id: [parseInt(userInfo.serviroutes_company_id)],
				fields: period === "all" ? [] : [period, "total", "service", "optimization_api"],
				optimization_api: ["OPENROUTE", "GMPRO", "TOUR_PLANNING"],
			};
			this.openLoadingContent("#used-content-loading");
			this.$store
				.dispatch("optimizerManager/optimizerManagerFilter", payload)
				.then((res) => {
					const serviceTotalsMap = {
						OPENROUTE: {
							optimization: "totalOptimizationServiceOpenroute",
							routing: "totalRoutingServiceOpenroute",
							matrix: "totalMatrixServiceOpenroute",
							mapmatching: "totalMapMatchingServiceOpenroute",
							isochrones: "totalIsochronesServiceOpenroute",
						},
						GMPRO: {
							optimization: "totalOptimizationServiceGmpro",
							routing: "totalRoutingServiceGmpro",
							matrix: "totalMatrixServiceGmpro",
							mapmatching: "totalMapMatchingServiceGmpro",
							isochrones: "totalIsochronesServiceGmpro",
						},
						TOUR_PLANNING: {
							optimization: "totalOptimizationServiceTourPlanning",
							routing: "totalRoutingServiceTourPlanning",
							matrix: "totalMatrixServiceTourPlanning",
							mapmatching: "totalMapMatchingServiceTourPlanning",
							isochrones: "totalIsochronesServiceTourPlanning",
						},
					};
					const periodMap = {
						all: "total",
						total_last_1_day: "total_last_1_day",
						total_last_7_days: "total_last_7_days",
						total_last_month: "total_last_month",
						total_current_subscription: "total_current_subscription",
					};
					const selectedPeriod = periodMap[this.selectedUsedService.value];
					// Asignar valores a las propiedades dinámicas
					res.records.forEach((item) => {
						const serviceTotals = serviceTotalsMap[item.optimization_api];
						if (serviceTotals) {
							const totalKey = serviceTotals[item.service];
							if (totalKey && item[selectedPeriod] !== undefined) {
								this[totalKey] = item[selectedPeriod];
							}
						}
					});
					this.closeLoadingContent("#used-content-loading");
				})
				.catch((err) => {
					this.closeLoadingContent("#used-content-loading");
					console.error(err);
				});
		},
		getManagerOptimizerByRouter(router, period) {
			const userInfo = JSON.parse(localStorage.getItem("userInfo"));
			let payload = {
				company_id: [parseInt(userInfo.serviroutes_company_id)],
				optimization_api: [router],
				fields: [
					period,
					"service",
					"points_per_day",
					"points_per_week",
					"points_per_month",
					"points_subscription_monthly",
					"points_total",
				],
			};
			if (period !== "total") payload.fields.push("total");
			this.openLoadingContent("#limit-period-content-loading");
			this.$store
				.dispatch("optimizerManager/optimizerManagerFilter", payload)
				.then((res) => {
					this.limitedVsUsedServices = res.records;
					this.closeLoadingContent("#limit-period-content-loading");
				})
				.catch((err) => {
					console.error(err);
					this.closeLoadingContent("#limit-period-content-loading");
				});
		},
		nextCard() {
			if (this.currentIndex < this.cards.length - this.cardsPerPage) {
				this.currentIndex++;
				this.getManagerOptimizerByRouter(this.cards[this.currentIndex], this.selectedPeriod.value);
			}
		},
		previousCard() {
			if (this.currentIndex > 0) {
				this.currentIndex--;
				this.getManagerOptimizerByRouter(this.cards[this.currentIndex], this.selectedPeriod.value);
			}
		},
		filterByPeriod(period) {
			const periodMap = {
				total: {label: this.$t("Totalconsumption"), value: "total"},
				total_last_1_day: {label: this.$t("Last1Day"), value: "total_last_1_day"},
				total_last_7_days: {label: this.$t("Last7Days"), value: "total_last_7_days"},
				total_last_month: {label: this.$t("LastMonth"), value: "total_last_month"},
				total_current_subscription: {
					label: this.$t("TotalSubscriptionMonthly"),
					value: "total_current_subscription",
				},
			};
			if (periodMap[period]) {
				this.selectedPeriod = periodMap[period];
				this.getManagerOptimizerByRouter(this.cards[this.currentIndex], period);
			}
		},
		filterByUsedService(period) {
			const periodMap = {
				all: {label: this.$t("Totalconsumption"), value: "all"},
				total_last_1_day: {label: this.$t("Last1Day"), value: "total_last_1_day"},
				total_last_7_days: {label: this.$t("Last7Days"), value: "total_last_7_days"},
				total_last_month: {label: this.$t("LastMonth"), value: "total_last_month"},
				total_current_subscription: {
					label: this.$t("TotalSubscriptionMonthly"),
					value: "total_current_subscription",
				},
			};
			if (periodMap[period]) {
				this.selectedUsedService = periodMap[period];
				this.getManagerOptimizer(period);
			}
		},
	},
};
</script>

<style lang="scss">
.chat-card-log {
	height: 400px;

	.chat-sent-msg {
		background-color: #f2f4f7 !important;
	}
}
#limit-period-div {
	.vx-card {
		height: 540px !important;
	}
}
</style>
